export default {"src":"/_next/static/image/public/images/aster_secure_logo_white.7ebdfc4b23d22392a72b7a16747ad1b3.svg","height":31,"width":94};